module.exports = __webpack_public_path__ + "static/media/msk.1b028e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Offices/img/msk.png
// module id = 805
// module chunks = 0